import * as yup from 'yup';
import { parsePhoneNumberFromString } from 'libphonenumber-js/max';
import { noSpaces, emailRegex } from '../../utils/regexs';

export interface CheckoutFormData {
  contactMethod: 'phone' | 'email';
  email?: string;
  emailConfirm?: string;
  phone?: string;
  phoneConfirm?: string;
}

export const checkoutValidationSchema = yup.object<CheckoutFormData>().shape({
  contactMethod: yup
    .mixed<'phone' | 'email'>()
    .oneOf(['phone', 'email'])
    .required(),
  email: yup.string().when('contactMethod', {
    is: 'email',
    then: (schema) => schema
      .required('Debes ingresar un correo')
      .matches(emailRegex, 'Este correo no está bien')
      .test('no-spaces', 'No se permiten espacios', noSpaces),
    otherwise: (schema) => schema.optional(),
  }),
  emailConfirm: yup.string().when('contactMethod', {
    is: 'email',
    then: (schema) => schema
      .required('Debes ingresar un correo')
      .oneOf([yup.ref('email')], 'Los correos no coinciden')
      .test('no-spaces', 'No se permiten espacios', noSpaces),
    otherwise: (schema) => schema.optional(),
  }),
  phone: yup.string().when('contactMethod', {
    is: 'phone',
    then: (schema) => schema
      .required('Debes ingresar un celular')
      .test('is-valid-phone', 'Ingresá un celular válido', (value) => {
        if (!value) {
          return false;
        }
        const pn = parsePhoneNumberFromString(value);
        return !!pn && pn.isValid();
      }),
    otherwise: (schema) => schema.optional(),
  }),
  phoneConfirm: yup.string().when('contactMethod', {
    is: 'phone',
    then: (schema) => schema
      .required('Debes ingresar un celular')
      .oneOf([yup.ref('phone')], 'Los teléfonos no coinciden'),
    otherwise: (schema) => schema.optional(),
  }),
});
